<fullscreen-page class="np-detail-layout">
  <div class="np-detail-left">
    <div class="np-detail-header">
      <div class="np-detail-title-row">
        <dx-button
          class="np-detail-back-btn"
          icon="chevronleft"
          stylingMode="text"
          (onClick)="goBack()"
        ></dx-button>

        <div class="np-detail-title text-truncate">
          {{ containerName }}
        </div>
      </div>
    </div>
  </div>
</fullscreen-page>
